import React, { useEffect, useRef, useState } from 'react';
import { View } from 'react-native';
import { useToast } from 'react-native-toast-notifications';
import { Page, DataGrid, BText, DataGridColumn, showToast, Drawer, PageTitle } from '../../../../components';
import { Button, Input, InputRefProps, ButtonContainer } from '../../../../components/Form';
import { UserInputSchema } from '../../../../types';
import eventTypeJson from '../../../../assets/data/eventType.json';

export const AdminEventEventType = () => {
  type EventTypeObject = {
    id: number;
    type: string;
    status: boolean;
  };

  const toast = useToast();
  const [isAddView, setIsAddView] = useState<boolean>(false);
  const [isEditView, setIsEditView] = useState<boolean>(false);
  const [selectedId, setSelectedId] = useState<number>(0);
  const [typeName, setTypeName] = useState<string>('');
  const inputTypeName = useRef<InputRefProps>(null);
  const [showDelete, setShowDelete] = useState<boolean>(false);
  const [selectedType, setSelectedType] = useState<any>(null);
  const [eventType, setEventType] = useState(eventTypeJson);

  useEffect(() => {
    updateInputValue(inputTypeName.current, '');
  }, []);

  useEffect(() => {
    setSelectedId(selectedId);
  }, []);

  const column: DataGridColumn[] = [
    { label: 'Event Type', key: 'type', width: 100, sortable: true },
    {
      label: 'Status',
      key: 'status',
      width: 100,
      sortable: true,
      dataType: 'boolean',
      cellRender: (item: any) => <BText>{` ${item.status ? 'Active' : 'Inactive'}`}</BText>,
    },
  ];

  const handleActivationItem = (selectedItemIndex: any) => {
    const itemsToSelect = eventType.map(item => {
      if (selectedItemIndex.id === item.id) {
        return {
          ...item,
          status: !item.status,
        };
      }
      return item;
    }, []);
    setEventType(itemsToSelect);
    showToast(toast, {
      message: selectedItemIndex.status
        ? `${selectedItemIndex.type} is disabled`
        : `${selectedItemIndex.type} is enabled`,
    });
  };

  const updateInputValue = (element: InputRefProps | null, value: string) => {
    if (element) element.setValue(value);
  };

  const incrementId = () => {
    return isEditView ? selectedId : eventType[eventType.length - 1].id + 1;
  };

  const doSaveBtn = async () => {
    const newType: EventTypeObject = {
      id: incrementId(),
      type: inputTypeName.current?.value || '',
      status: true,
    };
    handleAddOrUpdate(newType);
    setIsAddView(false);
    clearInputValue();
  };

  const handleAddOrUpdate = (newType: EventTypeObject) => {
    const existingTypeIndex = eventType.findIndex(type => type.id === newType.id);

    if (existingTypeIndex !== -1) {
      const updatedTypeData = [...eventType];
      updatedTypeData[existingTypeIndex] = newType;
      setEventType(updatedTypeData);
    } else {
      setEventType(prevData => [...prevData, newType]);
    }
  };

  const doCancelBtn = () => {
    setIsAddView(false);
    setIsEditView(false);
    clearInputValue();
  };

  const showEditItemView = (showSelectedType: any) => {
    setIsAddView(true);
    setIsEditView(true);
    populateSelectedEditItem(showSelectedType);
  };

  const populateSelectedEditItem = (populateSelectedType: any) => {
    setTypeName(populateSelectedType.type);
    setSelectedId(populateSelectedType.id);
  };

  const showDeleteDrawer = (selectedItemIndex: any) => {
    setSelectedType(selectedItemIndex);
    setShowDelete(true);
  };

  const handleDeleteItem = () => {
    const updatedTypeData = eventType.filter(type => type.type !== selectedType.type);
    setEventType(updatedTypeData);
  };

  const clearInputValue = () => {
    if (!isAddView) {
      setTypeName('');
    }
  };

  return (
    <Page title={'Event Type Setup'}>
      {!isAddView && (
        <View>
          <DataGrid
            data={eventType}
            columns={column}
            actions={[
              {
                label: 'Active',
                action: (item: any) => handleActivationItem(item),
                disable: (item: any) => item.status,
              },
              {
                label: 'Deactivate',
                action: (item: any) => handleActivationItem(item),
                disable: (item: any) => !item.status,
              },
              {
                label: 'Edit',
                action: (item: any) => showEditItemView(item),
              },
              {
                label: 'Delete',
                action: (item: any) => showDeleteDrawer(item),
                disable: (item: any) => !item.status,
              },
            ]}
            defaultSort={{ key: 'type', direction: 'ascending' }}
            // onDoubleClick={(item: any) => console.log('DblClick', item)}
            onSelect={(item: any) => console.log('select', item)}
            primaryButton={{
              label: 'Add Event Type',
              action: () => setIsAddView(true),
            }}
          />
        </View>
      )}

      {isAddView && (
        <View>
          {!isEditView ? <PageTitle>Add New Event Type</PageTitle> : <PageTitle>Edit Event Type</PageTitle>}
          <Input
            label={'Event Type Name'}
            id="typeName"
            value={!isEditView ? '' : typeName}
            schemaObject={UserInputSchema}
            schemaContext={{ isEdit: true }}
            ref={inputTypeName}
          />
          <ButtonContainer direction="horizontal">
            <Button onPress={() => doSaveBtn()}>Save</Button>
            <Button onPress={() => doCancelBtn()}>Cancel</Button>
          </ButtonContainer>
        </View>
      )}

      <Drawer
        id="type.delete"
        visible={showDelete}
        type={'onCancel'}
        onClose={() => setShowDelete(false)}
        onOK={handleDeleteItem}
        title={'Confirmation'}
      >
        <BText>Are you confirm to delete the state?</BText>
      </Drawer>
    </Page>
  );
};
